// hooks/useCompanyConfig.js
import { useEffect, useState } from "react";
import { getConfig } from "../services/Services";
import { generateErrorMessage } from "../utils/GenerateMessage";

export const useCompanyConfig = () => {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);

  const getCompanyConfig = async () => {
    try {
      const res = await getConfig();
      if (res?.status === 200) {
        setConfig(res?.data?.data?.companyModuels || {});
      } else {
        generateErrorMessage("Something went wrong.");
      }
    } catch (error) {
      generateErrorMessage(
        error?.response?.data?.message || "Something Went Wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCompanyConfig();
  }, []);

  return { config, loading };
};
